import React, { useCallback, useEffect, useState ,useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { LoaderExt} from 'gw-components-platform-react';
import { ModalNextContext, Loader } from '@jutro/components';
import { ServiceManager } from '@jutro/legacy/services';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';

import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { PaymentComponentExt } from 'cpmi-components-platform-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import metadata from './MakePaymentPage.metadata.json5';
import messages from './MakePaymentPage.messages';
import styles from './MakePaymentPage.scss';
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';
import { AccountDropDownValues,ProducerContext } from '../../cpmi_SelectAccountDropDown';
import { useRef } from 'react';

function MakePaymentPage(props) {
    
    const {showAlert}=useContext(ModalNextContext);
    const auth = useAuthentication();
    const { authHeader, history } = props;
    const localeService = ServiceManager.getService('locale-service');
    const defaultCurrencyCode = localeService.getDefaultCurrencyCode().toUpperCase();
    const [ trackGAPageView] = useGoogleAnalytics();
    const [accountNameTitle,setAccountNameTitle] = useState(undefined);
    const { AccountBillingDetailsService: BillingService } = useDependencies(
        'AccountBillingDetailsService'
    );

    
    // screen states
    const [isLoadingData, updateIsLoadingData] = useState(false)
    
    const [selectedInvoicesForPayment, updateSelectedInvoicesForPayment] = useState([]);
    const [selectedScreen, updateSelectedScreen] = useState('default');
    const [selectedCurrency, updateSelectedCurrency] = useState(defaultCurrencyCode);
    const [amountToPay, updateAmountToPay] = useState(null);
    const [invoiceData,setInvoiceData]=useState({});
    const [isGrandFatheredAccount, setIsGrandFatheredAccount] = useState(false);
    const [makeAPaymentDropDown,setMakeAPaymentDropDown] =useState(null);
    // const [availableMultiInvoiceStreams,setAvailableMultiInvoiceStreams] = useState([]);
    const [selectedInvoiceStreamDropDownValue, setSelectedInvoiceStreamDropDownValue] =useState(props?.location?.state?.multiInvoiceSelectedValue);
    const [selectedMultiInvoceStreamName, setSelectedMultiInvoceStreamName] = useState();
    const [streamInternalID, setStreamInternalID] = useState();
    const [multiStreamDropDownArray, setMultiStreamDropDownArray] = useState([]);
    const [originalInvoiceStreamLength, setOriginalInvoiceStreamLength] = useState(0);
    const initialRender=useRef(true);
    const [isAccountSelected,setIsAccountSelected]=useState(0);
    const [accountDataSet,setUserAccountDataSet] = useState(props?.location?.state?.accountsData);

    const {setMultiInvoiceDropDown}=useContext(ProducerContext);
    const [count,setCount] = useState()
    useEffect(()=>{
        if(props?.history?.location?.state?.page !=="LandingPage"){
            // eslint-disable-next-line array-callback-return
            props?.location?.state?.multiInvoiceStreamData?.map((looingItem)=>{
                if(looingItem.code === selectedInvoiceStreamDropDownValue){
                    setSelectedMultiInvoceStreamName(looingItem.name);
                    setStreamInternalID(looingItem.code);
                }
            })
            multiStreamDropDownArray.map((item)=>{
                if(item.code===selectedInvoiceStreamDropDownValue){
                    setSelectedMultiInvoceStreamName(item.name)
                }
            })
        }
    
        // const data=history.location.state.accountNumber;
        const data=makeAPaymentDropDown;
        if(makeAPaymentDropDown && selectedInvoiceStreamDropDownValue !==undefined){
            updateIsLoadingData(true);
            // BillingService.getAccountDuesInformation_Ext(data,authHeader).then((res)=>{
            //     setInvoiceData(res);
            //     // setAmountRemaining('');
            //     // setAmountRemaining(res?.totalAmountDue?.amount);
            //     // updateAmountToPay(null);
                
            //     updateIsLoadingData(false)
            // }).finally(()=>{
            //     updateIsLoadingData(false)
            // })
           
            BillingService.getAccountInvoiceDuesInformation_Ext(data,selectedInvoiceStreamDropDownValue,authHeader).then((res)=>{
                setInvoiceData(res);
                // setAmountRemaining('');
                // setAmountRemaining(res?.totalAmountDue?.amount);
                // updateAmountToPay(null);
                
                updateIsLoadingData(false)
            }).finally(()=>{
                updateIsLoadingData(false)
            })
            

            BillingService.getCreditCardLimitAllowedAccount(data,authHeader).then((res) => {
                setIsGrandFatheredAccount(res);         
            })
        }
        

    },[BillingService, authHeader, props?.history?.location?.state?.page, props?.location?.state?.multiInvoiceStreamData, selectedInvoiceStreamDropDownValue])

    useEffect(() => {
        trackGAPageView("/make-payment","Make a Payment")
    },[trackGAPageView])

    useEffect(()=>{
        if(initialRender.current && makeAPaymentDropDown){
            initialRender.current=false;
            // setSelectedInvoiceStreamDropDownValue(props.location.state.multiInvoiceSelectedValue)
            if(makeAPaymentDropDown && selectedInvoiceStreamDropDownValue !==undefined){
                BillingService.getAccountInvoiceDuesInformation_Ext(makeAPaymentDropDown,selectedInvoiceStreamDropDownValue,authHeader).then((res)=>{
                    setInvoiceData(res);
                    updateIsLoadingData(false)
                }).finally(()=>{
                    updateIsLoadingData(false)
                })
                BillingService.getCreditCardLimitAllowedAccount(makeAPaymentDropDown,authHeader).then((res) => {
                    setIsGrandFatheredAccount(res);         
                })
            }
        }
        // if(props.location.state.multiInvoiceSelectedValue!==selectedInvoiceStreamDropDownValue && makeAPaymentDropDown){
            
        // }
    },[BillingService, authHeader, makeAPaymentDropDown, selectedInvoiceStreamDropDownValue])

    useEffect(()=>{
        
        //setMultiStreamDropDownArray([])
        
        //setSelectedInvoiceStreamDropDownValue(undefined)
        if(props?.location?.state?.multiInvoiceStreamData?.length > 1 || props?.location?.state?.multiInvoiceStreamData?.length === 1 ){
            //setSelectedInvoiceStreamDropDownValue(props.location.state.multiInvoiceStreamData.code)
            
            setMultiStreamDropDownArray(props?.location?.state?.multiInvoiceStreamData)
        }
        if(props?.history?.location?.state?.dropdownMultiStreamData?.length > 1 ){
            setMultiStreamDropDownArray(props?.history?.location?.state?.dropdownMultiStreamData)
        }
        // if(props?.location?.state?.multiInvoiceStreamData?.length === 1 ){
            
        //     setSelectedInvoiceStreamDropDownValue(props.location.state.multiInvoiceStreamData[0].code)
        //     setSelectedMultiInvoceStreamName(props.location.state.multiInvoiceStreamData[0].name)
        // }
           
    },[props?.history?.location?.state?.dropdownMultiStreamData, props?.location?.state?.multiInvoiceStreamData,makeAPaymentDropDown,count])

    const updateInvoiceDropDown= useCallback((dropDownValue)=>{
       let invoiceDetailsPromise = BillingService.getSelectedAccountBillingSummary_Ext(dropDownValue,
            authHeader
        )
            .then((res)=>{
                const invoiceSTreamsArray = [];
                // eslint-disable-next-line array-callback-return
                const invoicesLength=res.allInvoiceStreamDetails?.length;
                let tempCount=0;
                setOriginalInvoiceStreamLength(res.allInvoiceStreamDetails.length)
                accountDataSet?.roles?.map((loopItm)=>{
                    // eslint-disable-next-line array-callback-return        
                    res.allInvoiceStreamDetails?.map((subItem)=>{
                        if(subItem?.internalId === loopItm?.invoiceId){
                            tempCount+=1;
                            invoiceSTreamsArray.push(
                                {
                                    name:subItem.displayName,
                                    code:subItem.internalId
                                })
                        }
                    })  
                })
                if(invoicesLength>=tempCount){
                    setCount(true)            
                }
                else{
                    setCount(false)
                }
                if(!invoicesLength>=tempCount ||invoicesLength===tempCount){
                    if (invoiceSTreamsArray.length === 1) {
                        setCount(false);
                        setSelectedInvoiceStreamDropDownValue(invoiceSTreamsArray[0]?.code);
                        setSelectedMultiInvoceStreamName(invoiceSTreamsArray[0]?.name)
                        setMultiInvoiceDropDown(invoiceSTreamsArray[0]?.code)
                    }
                } 
                setMultiStreamDropDownArray(invoiceSTreamsArray)
                if(isAccountSelected>2 && invoiceSTreamsArray.length>1)
                setSelectedInvoiceStreamDropDownValue(undefined)
            })
    },[BillingService, authHeader, isAccountSelected])

    

    useEffect(()=>{
        
        if(makeAPaymentDropDown!==null){
            updateInvoiceDropDown(makeAPaymentDropDown)
        }
        setInvoiceData([]);
        setIsGrandFatheredAccount([]);
        
    },[makeAPaymentDropDown, updateInvoiceDropDown])

    useEffect(()=>{
        setIsAccountSelected((prev)=>prev+1)},[makeAPaymentDropDown])

    
    const getDueAmount = useCallback(() => {
        if (invoiceData.totalAmountDue) return invoiceData.totalAmountDue.amount.toFixed(2);
        return '0.00'
    }, [invoiceData])

    

    // if (isLoadingData) {
    //     return <LoaderExt loaded={!isLoadingData} />;
    // }

    const handleValueChange = (value) => {
        
        setMakeAPaymentDropDown(value);
       
    }
    

    useEffect(()=>{
        updateIsLoadingData(true);
        if((props?.history?.location?.state?.showHideDropDownNew===true || props?.history?.location?.state?.creditCardFlag===true) && makeAPaymentDropDown===null){
            props.history.location.state.showHideDropDownNew=false;
            props.history.location.state.creditCardFlag=false;
        }
        
    },[makeAPaymentDropDown, props.history.location.state, props.history.location.state?.showHideDropDownNew])

    const getAccountName = useCallback((value) => {
        setAccountNameTitle(value[0]?.name?.split('  ')[1]);
    }, [])

    const getInvoiceDropValue = useCallback((value)=>{
        setSelectedInvoiceStreamDropDownValue(value);
    },[])

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top'
            },
        },
        
        makePaymentInvoicesTableComponentId: {
            invoiceSummary: invoiceData.invoicesToBePaid,
            selectedInvoices: selectedInvoicesForPayment,
            makepayment:'paymentpage',
            visible:selectedInvoiceStreamDropDownValue !==undefined
        },
        makePaymentSourceComponentId: {
            xCenter: 'bc',
            isDisabled: selectedInvoicesForPayment.length === 0,
            accountNumber:makeAPaymentDropDown,
            accountName:accountNameTitle,
            dueAmount:getDueAmount(),
            grandfatherdAccount:isGrandFatheredAccount,
            selectedMultiInvoceStreamName:selectedMultiInvoceStreamName,
            selectedInvoiceStreamDropDownValue:selectedInvoiceStreamDropDownValue,
            streamInternalID:streamInternalID,
            multiStreamDropDownArray:multiStreamDropDownArray,
            originalInvoiceStreamLength: originalInvoiceStreamLength,
            visible:selectedInvoiceStreamDropDownValue !==undefined

        },
        makePaymentAmountToPayId: {
            defaultCurrency: selectedCurrency,
            disabled: selectedInvoicesForPayment.length === 0,
            onValueChange: updateAmountToPay,
        },
        makePaymentContainerId:{
            visible:((props?.history?.location?.state?.page==="LandingPage" && (makeAPaymentDropDown!==null )) || props?.history?.location?.state?.page!=="LandingPage" && (makeAPaymentDropDown!==null )),
        },
        availableProducerCode:{
            removeSelected:props?.history?.location?.state?.page==="LandingPage" && (makeAPaymentDropDown===null ),
            getAccountName:getAccountName,
            multiInvoiceStreamValue:selectedInvoiceStreamDropDownValue,
            getInvoiceDropValue:getInvoiceDropValue,
            pageMakeAPayment:"MakePayment"
        },
        snapshotDetailstestNew:{
            visible:(props?.history?.location?.state?.showHideDropDownNew || props?.history?.location?.state?.creditCardFlag?false:(makeAPaymentDropDown===null?true:makeAPaymentDropDown!==null?true:false)) 
        },
        accountDropdown:{
            visible: (props?.history?.location?.state?.showHideDropDownNew || props?.history?.location?.state?.creditCardFlag?false:(makeAPaymentDropDown===null?true:makeAPaymentDropDown!==null?true:false)),
        },
        multiInvoiceStreamDropdown:{
            availableValues:multiStreamDropDownArray,
            visible:props?.history?.location?.state?.showHideDropDownNew || props?.history?.location?.state?.creditCardFlag?false:(count||(props?.history?.location?.state?.showHideDropDownNew || props?.history?.location?.state?.creditCardFlag?false:(makeAPaymentDropDown===null?true:makeAPaymentDropDown!==null?true:false))),
            onValueChange:(value,index)=>{
                setSelectedInvoiceStreamDropDownValue(value);
                // loadDataChangeEvent();
                setMultiInvoiceDropDown(value)
            },
            value:selectedInvoiceStreamDropDownValue,
            removeSelected:props?.history?.location?.state?.page==="LandingPage" && (makeAPaymentDropDown===null ),
            alwaysShowPlaceholder:selectedInvoiceStreamDropDownValue && false
        },
        makePaymentPageHeaderId:{
            visible: selectedInvoiceStreamDropDownValue !==undefined
        },
        makePaymentInvoicesTableTitleId:{
            visible:selectedInvoiceStreamDropDownValue !==undefined
        },
        multiInvoiceStream:{
            visible:count||multiStreamDropDownArray.length!==1
        }
    
    };

    const dataForComponent = {
        amountToPay
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            paymentcomponent: PaymentComponentExt,
            AccountDropDownValues: AccountDropDownValues,
        },
        resolveCallbackMap: {
            handleValueChange,
        }
    };


    return (
        <ViewModelForm
            model={dataForComponent}
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

MakePaymentPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

export default withAuthenticationContext(withRouter(MakePaymentPage));